import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class PollService {
    async getSinglePollData(id) {
        const response = await axios.get(Config.apiBasePath + '/getPollById/' + id, {headers: authHeader()});
        return response;
    }

    async deletePoll(id) {
        const response = await axios.get(Config.apiBasePath + '/deletePoll/' + id, {headers: authHeader()});
        return response;
    }

    async savePollData(data) {
        const response = await axios.post(Config.apiBasePath + '/createNewPoll', data, {headers: authHeader()});
        return response;
    }

    async editPollData(data) {
        const response = await axios.post(Config.apiBasePath + '/updatePoll', data, {headers: authHeader()});
        return response;
    }

    async updatePollData(data) {
        const response = await axios.post(Config.apiBasePath + '/updatePoll', data, {headers: authHeader()});
        return response;
    }

    async getAllPollData(param) {
        const response = await axios.get(Config.apiBasePath + '/getPollList', {
            params: param,
            headers: authHeader()
        });
        return response;
    }
}

export default new PollService();
